import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { VehicleType } from '@evermile/customer-tracking';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';

@Component({
  selector: 'common-courier-info',
  templateUrl: './courier-info.component.html',
  styleUrls: ['./courier-info.component.scss'],
})
export class CourierInfoComponent implements OnInit, OnDestroy {
  @Input() brandColor!: string;
  @Input() textColor!: string;
  @Input() vehicleType?: VehicleType;
  @Input() courierName?: string;
  @Input() courierPhone?: string;
  @Input() orderStatus?: string;
  @Input() shouldShowContactDriverMessage?: boolean = false;
  @Input() contained?: boolean;

  vehicleTypeToIcon = {
    [VehicleType.Pushbike]: 'vehicleTypeBike',
    [VehicleType.Motorbike]: 'vehicleTypeMotorbike',
    [VehicleType.CargoBike]: 'vehicleTypeCargoBike',
    [VehicleType.Car]: 'vehicleTypeCar',
    [VehicleType.SmallVan]: 'vehicleTypeSmallVan',
    [VehicleType.LargeVan]: 'vehicleTypeLargeVan',
  };

  vehicleTypeIcon: string = this.vehicleTypeToIcon[VehicleType.Car];
  mobileMode = false;
  private subMobileMode?: Subscription;

  constructor(private breakpointObserver: BreakpointObserver) {}

  ngOnInit(): void {
    if (this.vehicleType) {
      this.vehicleTypeIcon = this.vehicleTypeToIcon[this.vehicleType];
    }

    this.subMobileMode = this.breakpointObserver.observe(['(max-width: 1024px)']).subscribe((result) => {
      this.mobileMode = result.matches;
    });
  }

  ngOnDestroy(): void {
    if (this.subMobileMode) this.subMobileMode.unsubscribe();
  }
}
